<template>
  <div class="row-loading-animation">
    <div v-if="columnType==='addressImg'" class="addressImg">
      <div class="loading-img moving-gradient" />
      <div class="loading-address moving-gradient" />
    </div>
    <div v-else-if="columnType==='checkbox'" class="checkbox" />
  </div>
</template>

<script>
export default {
  props: {
    columnType: {
      type: String,
      default: 'text'
    }
  }
}
</script>

<style lang="sass" scoped>
.row-loading-animation
  width: 100%
  height: 100%
  padding: .5rem

.addressImg
  display: flex
  align-items: center
  height: 100%

  .loading-img
    height: 100%
    width: 120px
    margin-right: 2rem
    animation-duration: 2s

  .loading-address
    height: 1.4rem
    width: 60%
    animation-duration: 1s

.moving-gradient
  background: linear-gradient(to right, #f2f2f2 20%, $hwayzec 50%, #f2f2f2 80%)
  background-size: 20rem 10rem
  animation-name: moving-gradient
  animation-iteration-count: infinite
  animation-timing-function: linear
  animation-fill-mode: forwards

@keyframes moving-gradient
  0%
    background-position: -10rem 0
  100%
    background-position: 10rem 0

@-webkit-keyframes moving-gradient
  0%
    background-position: -10rem 0
  100%
    background-position: 10rem 0
</style>
